import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FuseSearchBarModule, FuseShortcutsModule } from '@fuse/components';
import { FuseSharedModule } from '@fuse/shared.module';
import { ToolbarComponent } from 'app/layout/components/toolbar/toolbar.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatBadgeModule, MatPaginatorModule, MatSidenavModule } from '@angular/material';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { MatDialogModule } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { ReactiveFormsModule } from '@angular/forms';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { MatSelectModule } from '@angular/material/select';
import { WorkStatusComponent } from './work-status/work-status.component';
import { ClockComponent } from './clock/clock.component';
import { SharedModule } from 'app/shared/shared.module';

@NgModule({
    declarations: [
        ToolbarComponent,
        WorkStatusComponent,
        ClockComponent
    ],
    imports: [
        RouterModule,
        BrowserAnimationsModule,
        MatButtonModule,
        MatIconModule,
        MatMenuModule,
        MatToolbarModule,
        FuseSharedModule,
        FuseSearchBarModule,
        FuseShortcutsModule,
        MatTooltipModule,
        MatBadgeModule,
        MatPaginatorModule,
        MatSidenavModule,
        ScrollingModule,
        MatDialogModule,
        MatInputModule,
        ReactiveFormsModule,
        NgxMaterialTimepickerModule,
        MatSelectModule,
        SharedModule
    ],
    exports: [
        ToolbarComponent
    ],
    entryComponents: [
        ClockComponent
    ]
})

export class ToolbarModule {

}
